import React from 'react';
// icons
import { BsArrowRightShort, BsQuestionDiamond } from 'react-icons/bs';
import { Link } from 'react-router-dom';

// components
import AampeIconBackground from '../../../../components/shared/AampeIconBackground/AampeIconBackground';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';
// constants
import routes from '../../../../constants/routes';

const TestPushProvider: React.FC<React.PropsWithChildren<unknown>> = () => {
    return (
        <>
            <AampeIconBackground
                primaryColor={aampeTheme.colors.primary50}
                secondaryColor={aampeTheme.colors.primary100}
            >
                <BsQuestionDiamond color={aampeTheme.colors.solidA01} />
            </AampeIconBackground>
            <Paragraph>
                In order to send test messages you first need to setup your push
                provider.
            </Paragraph>
            <FooterParagraph>
                To visit the configuration click here
                <BsArrowRightShort />
                <StyledLink to={routes.integrationMessage}>
                    View Push providers{' '}
                </StyledLink>
            </FooterParagraph>
        </>
    );
};

const Paragraph = styled.p(() => ({
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: 500,
}));

const FooterParagraph = styled.p(() => ({
    fontSize: '14px',
    color: aampeTheme.colors.neutral09,
    display: 'flex',
    alignItems: 'center',
}));

const StyledLink = styled(Link)`
    font-size: 14px;
    font-weight: 600;
    color: ${aampeTheme.colors.solidA01};
    text-decoration: none;
`;

export default TestPushProvider;
